<template>
  <el-table-column
    prop="value"
    label="Érték"
    align="right"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.net_purchase_price | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'value',
};
</script>
